var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/spoiler-input.tsx";
import classNames from 'clsx';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { changeComposeSpoilerness, changeComposeSpoilerText } from 'soapbox/actions/compose';
import AutosuggestInput from 'soapbox/components/autosuggest-input';
import { Divider, Stack, Text } from 'soapbox/components/ui';
import { useAppDispatch, useCompose } from 'soapbox/hooks';
const messages = defineMessages({
  title: {
    "id": "compose_form.spoiler_title",
    "defaultMessage": "Sensitive content"
  },
  placeholder: {
    "id": "compose_form.spoiler_placeholder",
    "defaultMessage": "Write your warning here (optional)"
  },
  remove: {
    "id": "compose_form.spoiler_remove",
    "defaultMessage": "Remove sensitive"
  }
});

/** Text input for content warning in composer. */
const SpoilerInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    composeId,
    onSuggestionsFetchRequested,
    onSuggestionsClearRequested,
    onSuggestionSelected
  } = _ref;
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const compose = useCompose(composeId);

  const handleChangeSpoilerText = e => {
    dispatch(changeComposeSpoilerText(composeId, e.target.value));
  };

  const handleRemove = () => {
    dispatch(changeComposeSpoilerness(composeId));
  };

  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    className: classNames({
      'relative transition-height': true,
      'hidden': !compose.spoiler
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Divider, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 9
    }
  }, intl.formatMessage(messages.title)), /*#__PURE__*/React.createElement(AutosuggestInput, {
    placeholder: intl.formatMessage(messages.placeholder),
    value: compose.spoiler_text,
    onChange: handleChangeSpoilerText,
    disabled: !compose.spoiler,
    suggestions: compose.suggestions,
    onSuggestionsFetchRequested: onSuggestionsFetchRequested,
    onSuggestionsClearRequested: onSuggestionsClearRequested,
    onSuggestionSelected: onSuggestionSelected,
    searchTokens: [':'],
    id: "cw-spoiler-input",
    className: "rounded-md dark:!bg-transparent !bg-transparent",
    ref: ref,
    autoFocus: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "text-danger-500",
    onClick: handleRemove,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 11
    }
  }, intl.formatMessage(messages.remove)))));
});
export default SpoilerInput;